export const USER_LEVEL = {
    ADMIN: 'Admin',
    AGGREGATOR: 'Aggregator',
    FRANCHISE: 'Franchise',
    MLE: 'MLE',
    MERCHANT: 'Merchant',
    RM: 'RM',
};

/**
 * Enum for user levels.
 * @readonly
 * @enum {string}
 */
export const USER_LEVEL_ENUM = {
    L1: 'L1',
    L2: 'L2',
    L3: 'L3',
};

export const MAX_USER_FETCH_COUNT_USER_MANAGEMENT = 100;

// This can removed in future.
export const USER_STATUS = {
    REGISTERED: 'Checker Pending',
    CHECKER_VERIFIED: 'Checker Verified',
    CHECKER_REJECTED: 'Checker Rejected',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export const USER_STATUS_UPDATED = {
    CHECKER_VERIFIED: 'Checker Verified',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export const ENTITY_TYPE = {
    AGGREGATOR: 'Aggregator',
    FRANCHISE: 'Franchise',
    MLE: 'MLE',
    MERCHANT: 'Merchant',
    RESELLER: 'Reseller ',
    RM: 'RM',
    PARTNER : 'Partner',
    MBE: 'MBE',
};

export const ROLE_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export const USER_ACTIONS_MAP = {
    USER_CREATION: 'Create',
    USER_UPDATION: 'Update',
};
export const ROLE_ACTIONS_MAP = {
    ROLE_CREATION: 'Create',
    ROLE_UPDATION: 'Update',
};

export const ROLE_MAP = {
    REGISTERED: 'Inprocess',
    CHECKER_VERIFIED: 'Approved',
    CHECKER_REJECTED: 'Rejected',
};

export const STATUS_MAP = {
    Inprocess: 'UNDER_APPROVAL',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
};

export const FORM_TYPE = {
    MERCHANT_ON_BOARD: 'merchantOnboardingForm',
    MLE_ON_BOARD: 'mleOnboardingForm'
};

export const SECTION_LIST = {
    createMerchantSection: 'MERCHANT',
    integrationSection: 'INTEGRATION',
    paymentModeSection: 'PAYMENTMODE',
    notificationSection: 'NOTIFICATION',
    settlementSection: "SETTLEMENT",
};

export const TRANSACTION_TYPE = {
    PAY: 'Pay',
    REFUND: 'Refund',
    ROLLBACK: 'Rollback',
    PAY_DELAYED: 'Pay Delayed',
    ACCOUNT_VERIFICATION: 'Account Verification',
    INSTANT_REFUND: 'Instant Refund',
};

export const ADMIN_ONLY_TRANSACTION_TYPE = [
    TRANSACTION_TYPE.ROLLBACK,
    TRANSACTION_TYPE.PAY_DELAYED,
];

export const ADJUSTMENT_TYPE = {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
};

export const PAY_TRANSACTION_STATUS = {
    CREATED: 'Link Created',
    EXPIRED: 'Link Expired',
    SHARED: 'Link Shared',
    FAILED: 'Link Failed',
    TRANSACTION_FAILED: 'Transaction Failed',
    TRANSACTION_INITIATED: 'Transaction Initiated',
    TRANSACTION_SUCCESS: 'Transaction Success',
};
export const PAYMENT_PAGE_TRANSACTION_STATUS = {
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
};

export const STATUS_TYPE = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    REVOKED: 'Revoked'
};

export const TRANSACTION_STATUS = {
    SUCCESS: 'Success',
    PENDING: 'Pending',
    FAILED: 'Failed',
};

export const STATE_ENUM = {
    SUCCESS: 'Completed',
    IN_PROGRESS: 'Inprocess',
    FAILURE: 'Failed',
};

export const AUDIT_STATUS = {
    SUCCESS: 'Success',
    PENDING: 'Pending',
    FAILURE: 'Failure',
};

export const SETTLEMENT_STATUS = {
    INITIATED: 'INITIATED',
    DISBURSED: 'DISBURSED',
    SETTLED: 'SETTLED',
};

export const ENTITY_MAP = {
    0: 'AGGREGATOR',
    1: 'FRANCHISE',
    2: 'MLE',
    3: 'MERCHANT',
    4: 'RESELLER',
};

export const TAB_LIST = [
    {
        value: 'EMAIL',
        label: 'Email',
    },
    {
        value: 'SMS',
        label: 'SMS',
    },
    {
        value: 'WEBHOOK',
        label: 'Webhook',
    },
];

export const validityOptions = [
    {
        name: '1 Day',
        value: 1,
    },
    {
        name: '2 Days',
        value: 2,
    },
    {
        name: '3 Days',
        value: 3,
    },
    {
        name: '4 Days',
        value: 4,
    },
    {
        name: '5 Days',
        value: 5,
    },
    {
        name: '6 Days',
        value: 6,
    },
    {
        name: '7 Days',
        value: 7,
    },
    {
        name: '8 Days',
        value: 8,
    },
    {
        name: '9 Days',
        value: 9,
    },
    {
        name: '10 Days',
        value: 10,
    },
    {
        name: '11 Days',
        value: 11,
    },
    {
        name: '12 Days',
        value: 12,
    },
    {
        name: '13 Days',
        value: 13,
    },
    {
        name: '14 Days',
        value: 14,
    },
    {
        name: '15 Days',
        value: 15,
    },
];

export const TEST_PREFIX = 'test_';
export const DEFAULT_CURRENCY = '₹';

export const dateOptions = [
    {
        label: 'Last 1 Hour',
        value: '1Hour',
    },
    {
        label: 'Today',
        value: 'today',
    },
    {
        label: 'Yesterday',
        value: 'yesterday',
    },
    {
        label: 'Last 7 Days',
        value: '7Days',
    },
    {
        label: 'Last 30 Days',
        value: '30Days',
    },
    {
        label: 'Last 180 Days',
        value: '180Days',
    },
    {
        label: 'Last 1 Year',
        value: '1Year',
    },
    {
        label: 'Custom',
        value: 'custom',
    },
];

export const trendLegends = {
    SUCCESS: {
        label: 'Successful',
        color: '#54ac06',
    },
    PENDING: {
        label: 'Pending',
        color: '#ffd900',
    },
    FAILED: {
        label: 'Failed',
        color: '#d71717',
    },
};

export const bankLegends = {
    DC: {
        label: 'Debit Card',
        color: '#F16122',
    },
    CC: {
        label: 'Credit Card',
        color: '#a8a9ad',
    },
    NB: {
        label: 'Net Banking',
        color: '#ec1264',
    },
    UPI: {
        label: 'UPI',
        color: '#f9b234',
    },
    WALLET: {
        label: 'Wallet',
        color: '#0096FF',
    },
    EMI_CC: {
        label: 'EMI CC',
        color: '#03fcd7',
    },
    overall: {
        label: 'Over All',
        color: '#54ac06',
    },
};

export const barLegends = {
    DC: {
        label: 'Debit Card',
        color: '#F16122',
    },
    CC: {
        label: 'Credit Card',
        color: '#a8a9ad',
    },
    NB: {
        label: 'Net Banking',
        color: '#ec1264',
    },
    UPI: {
        label: 'UPI',
        color: '#f9b234',
    },
    WALLET: {
        label: 'Wallet',
        color: '#0096FF',
    },
    EMI_CC: {
        label: 'EMI CC',
        color: '#03fcd7',
    },
};

export const pieLegends = {
    ALL: {
        label: 'All',
        color: '#F16122',
    },
    DC: {
        label: 'Debit card',
        color: '#F16122',
    },
    CC: {
        label: 'Credit card',
        color: '#6c6d70',
    },
    NB: {
        label: 'Net Banking',
        color: '#ec1264',
    },
    UPI: {
        label: 'UPI',
        color: '#f9b234',
    },
    WALLET: {
        label: 'Wallet',
        color: '#0096FF',
    },
    EMI_CC: {
        label: 'EMI CC',
        color: '#0096FF',
    },
    VI: {
        label: 'Visa',
        color: '#f9a619',
    },
    MC: {
        label: 'Master Card',
        color: '#cc1c01',
    },
    AMEX: {
        label: 'Amex',
        color: '#3f51b5',
    },
    RPAY: {
        label: 'Rupay',
        color: '#009688',
    },
    others: {
        label: 'Others',
        color: '#a8a9ad',
    },
    rank1: {
        color: '#f9a619',
    },
    rank2: {
        color: '#cc1c01',
    },
    rank3: {
        color: '#3f51b5',
    },
    rank4: {
        color: '#009688',
    },
    rank5: {
        color: '#363791',
    },
};

export const successRateTab = [
    {
        label: 'All',
        value: 'ALL_SUCCESS',
    },
    {
        label: 'Debit Card',
        value: 'DC_SUCCESS',
    },
    {
        label: 'Credit Card',
        value: 'CC_SUCCESS',
    },
    {
        label: 'UPI',
        value: 'UPI_SUCCESS',
    },
    {
        label: 'Wallet',
        value: 'WALLET_SUCCESS',
    },
    {
        label: 'Net Banking',
        value: 'NB_SUCCESS',
    },
    {
        label: 'EMI CC',
        value: 'EMI_CC_SUCCESS',
    },
];
export const GRANULE_VALUES = [
    'DAILY',
    'FIFTEENMINUTE',
    'HOURLY',
    'MONTHLY',
    'WEEKLY',
];
export const failureRateTab = [
    {
        label: 'Over All',
        value: 'ALL_FAILURE',
    },
    {
        label: 'Debit Card',
        value: 'DC_FAILURE',
    },
    {
        label: 'Credit Card',
        value: 'CC_FAILURE',
    },
    {
        label: 'UPI',
        value: 'UPI_FAILURE',
    },
    {
        label: 'Wallet',
        value: 'WALLET_FAILURE',
    },
    {
        label: 'Net Banking',
        value: 'NB_FAILURE',
    },
    {
        label: 'EMI CC',
        value: 'EMI_CC_FAILURE',
    },
];

export const dateOptionsSettlement = [
    {
        label: 'Today',
        value: 'today',
    },
    {
        label: 'Last 1 Hour',
        value: '1Hour',
    },
    {
        label: 'Last 12 Hour',
        value: '12Hour',
    },
    {
        label: 'Yesterday',
        value: 'yesterday',
    },
    {
        label: 'Last 3 Days',
        value: '3Days',
    },
    {
        label: 'Last 7 Days',
        value: '7Days',
    },
    {
        label: 'Custom',
        value: 'custom',
    },
];

export const transactionTypeNameMap = {
    INSTANT_REFUND: 'Instant Refund',
    PAY: 'Payment',
    MNDT_REG_PAY: 'Mandate Registration Fee',
    MNDT_EXE_PAY: 'Mandate Execution Fee',
};

// Defined an array of user levels for which we should not fetch entity lists.
export const EXCLUDED_ENTITY_USER_LEVELS = ['ADMIN', 'RM'];

/**
 * Mapping of section types to their corresponding step names.
 * Use this map to translate section types into step names.
 */
export const SECTION_TYPE_TO_STEP_MAP = {
    paymentModeSection: 'paymode',
    settlementSection: 'settlement',
    surchargeSection: 'surcharge',
    kycSection: 'kyc',
};

export const MAKER_CHECKER_EVENT_TYPES = {
    INTEGRATION: 'INTEGRATION',
    PAYMENTMODE: 'PAYMENTMODE',
    NOTIFICATION: 'NOTIFICATION',
    SETTLEMENT: 'SETTLEMENT',
    BTS_ACCOUNT: 'BTS_ACCOUNT',
    ROUTING: 'ROUTING',
    PG_CONFIG: 'PG_CONFIG',
    MERCHANT: 'MERCHANT',
    KYC: 'KYC',
    PRICING: 'PRICING',
    SETTLEMENT_RETRY: 'SETTLEMENT_RETRY',
    ONBOARDING: 'ONBOARDING',
    TERMINAL: 'TERMINAL_ID_ONBOARD',
    TERMINAL_UPDATE: 'TERMINAL_ID_UPDATE',
    MLE_ONBOARDING: 'MLE_ONBOARDING',
    MLE_UPDATE_BUSINESS_DETAIL: 'MLE_UPDATE_BUSINESS_DETAIL',
    MLE_UPDATE_OWNERSHIP_DETAIL: 'MLE_UPDATE_OWNERSHIP_DETAIL',
};

export const MAKER_CHECKER_EVENT_TYPES_SECTION_MAP = {
    INTEGRATION: 'integration',
    PAYMENTMODE: 'pay-mode',
    NOTIFICATION: 'notification',
    SETTLEMENT: 'settlement',
    BTS_ACCOUNT: 'BTS_ACCOUNT',
    ROUTING: 'routing',
    PG_CONFIG: 'pg-conf',
    MERCHANT: 'merchant',
    KYC: 'kyc',
    PRICING: 'surcharge',
    SETTLEMENT_RETRY: 'SETTLEMENT_RETRY',
    ONBOARDING: 'ONBOARDING',
};

export const MAKER_CHECKER_EVENT_TYPES_TITLE_MAP = {
    INTEGRATION: 'Integration Section Update Checker View',
    PAYMENTMODE: 'Payment Mode Section Update Checker View',
    NOTIFICATION: 'Notification Section Update Checker View',
    SETTLEMENT: 'Settlement Section Update Checker View',
    BTS_ACCOUNT: 'BTS Account Section Update Checker View',
    ROUTING: 'Routing Section Update Checker View',
    PG_CONFIG: 'PG Config Section Update Checker View',
    MERCHANT: 'Merchant Section Update Checker View',
    KYC: 'KYC Section Update Checker View',
    PRICING: 'Pricing Section Update Checker View',
    SETTLEMENT_RETRY: 'Settlement Retry  Checker View',
    ONBOARDING: 'Onboarding Section  Checker View',
};

export const KYC_FIELD_NAME_TO_TITLE_MAP = {
    dlUrl: 'Driving License',
    panUrl: 'Pan Card',
    eBillUrl: 'Electricity Bill',
    aadharUrl: 'Aadhar Card',
    voterIdUrl: 'Voter ID',
    passPortUrl: 'Passport',
};

/**
 * Map representing possible transaction statuses for mandates.
 * @const {Object.<string, string>}
 * @readonly
 */
export const MANDATE_TRANSACTION_STATUS_MAP = {
    /**
     * Mandate transaction status: Created.
     * @type {string}
     */
    CREATED: 'Created',

    /**
     * Mandate transaction status: Initiated.
     * @type {string}
     */
    INITIATED: 'Initiated',

    /**
     * Mandate transaction status: Success.
     * @type {string}
     */
    SUCCESS: 'Success',

    /**
     * Mandate transaction status: Failed.
     * @type {string}
     */
    FAILED: 'Failed',
};

export const MANDATE_FREQUENCY_ENUM = {
    ADHO: 'Adhoc',
    MNTH: 'Monthly',
    YEAR: 'Yearly',
};

export const CHARGEBACK_STATUS_ENUM = {
    PENDING_RESPONSE: {
        value: 'PENDING_RESPONSE',
        label: 'Pending Merchant Response',
    },
    PENDING_DOC_REVIEW: {
        label: 'Pending Documents Review',
        value: 'PENDING_DOC_REVIEW',
    },
    SUBMITTED_TO_BANK: {
        label: 'Submitted to Bank',
        value: 'SUBMITTED_TO_BANK',
    },
    INSUFFICIENT_DOCUMENT: {
        label: 'Insufficient Document',
        value: 'INSUFFICIENT_DOCUMENT',
    },
    CLOSED_IN_CUSTOMER_FAVOUR: {
        label: 'Closed in customer favour',
        value: 'CLOSED_IN_CUSTOMER_FAVOUR',
    },
    CLOSED_IN_MERCHANT_FAVOUR: {
        label: 'Closed in merchant favour',
        value: 'CLOSED_IN_MERCHANT_FAVOUR',
    },
    OPEN: {
        label: 'Open',
        value: 'OPEN',
    },
    CLOSED: {
        label: 'Close',
        value: 'CLOSED',
    }

};

export const DISPUTE_STATUS_ENUM = {

    INTITIATED: {
        value: 'INTITIATED',
        label: 'Initiated',
    },
    FULL_REFUND: {
        label: 'Fully Refund Raised',
        value: 'FULL_REFUND_RAISED',
    },
    PARTIAL_REFUND: {
        label: 'Partial Refund Raised',
        value: 'PARTIAL_REFUND_RAISED',
    },
    CLOSED: {
        label: 'Closed',
        value: 'CLOSED',
    },
    OPEN: {
        label: 'Open',
        value: 'OPEN',
    },

};

export const CHARGEBACK_TERMINAL_STATE = [
    'CLOSED_IN_CUSTOMER_FAVOUR',
    'CLOSED_IN_MERCHANT_FAVOUR',
];

export const CHARGEBACK_UPDATE_TERMINAL_STATE = [
    'CLOSED_IN_CUSTOMER_FAVOUR',
    'CLOSED_IN_MERCHANT_FAVOUR',
    'INSUFFICIENT_DOCUMENT',
];

export const CHARGEBACK_MERCHANT_STATUS_ENUM = {
    FULLY_ACCEPT: 'Accepted',
    PARTIALLY_ACCEPT: 'Partially Accept',
    CONTEST: 'Defend',
    PENDING: 'Pending',
};

export const POPUP_ENUM = {
    UPDATE_FORM: 'UPDATE_FORM',
    EXTEND_DEADLINE_FORM: 'EXTEND_DEADLINE_FORM',
    RE_RAISE_CHARGEBACK_FORM: 'RE_RAISE_CHARGEBACK_FORM',
    CHARGEBACK_FULLY_ACCEPT: 'CHARGEBACK_FULLY_ACCEPT',
    CHARGEBACK_DEFEND: 'CHARGEBACK_DEFEND',
    UPDATE_DISPUTE: 'UPDATE_DISPUTE',
};

export const POPUP_TITLE_ENUM = {
    UPDATE_FORM: 'Update Chargeback Status',
    EXTEND_DEADLINE_FORM: 'Extend Chargeback Deadline by',
    RE_RAISE_CHARGEBACK_FORM: 'Reraise Chargeback - L1',
    CHARGEBACK_DEFEND: 'Defend Chargeback',
    UPDATE_DISPUTE: 'Refund',
};

export const PAYMENT_MODE = [
    {
        label: 'Debit Card',
        value: 'DC',
    },
    {
        label: 'Credit Card',
        value: 'CC',
    },
    {
        label: 'Net Banking',
        value: 'NB',
    },
    // {
    //     label: 'UPI',
    //     value: 'UPI',
    // },
    {
        label: 'Wallet',
        value: 'WALLET',
    },
];

export const MAX_5MB = 5242880
export const MAX_25MB = 26214400

export const REPORT_TYPE_ENUM = {
    PG_MID_REPORT: 'PG_MID_REPORT',
};

export const MOCK_API_VALUE = 0; // do not login if value is 1

export const MAX_FILE_SIZE=5;
export const ACCEPT_IMG_PDF = 'image/*, .pdf';
export const ACCEPT_IMG_ONLY = 'image/*';

export const MAKER_CHECKER_EVENT_TYPES_MLE = {
    business: 'BUSINESS_DETAIL_SECTION',
    ubo: 'OWNERSHIP_DETAIL_SECTION',
    merchant:'MID_DETAILS_SECTION',
    risk: 'RISK_DETAIL_SECTION',
    legal: 'LEGAL_DETAILS',
    business_update: 'MLE_UPDATE_BUSINESS_DETAIL',
    ownership_update: 'MLE_UPDATE_OWNERSHIP_DETAIL',
    merchant_update: 'MLE_UPDATE_MERCHANT_DETAIL',
}

export const EVENT_TYPES = ['MLE_ONBOARDING', 'MLE_UPDATE_BUSINESS_DETAIL', 'MLE_UPDATE_OWNERSHIP_DETAIL'];

/*used for breadCrumbs Navigation*/
export const MAKER_CHECKER_EVENT_LABEL_MLE = (key) => {
    if (key == MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()) {
        return 'Business Details';
    } else if (key == MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()) {
        return 'UBO Details';
    }else if (key == MAKER_CHECKER_EVENT_TYPES_MLE.merchant.toLowerCase()) {
        return 'Merchant Details';
    } else if (key == MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()) {
        return 'Risk Details';
    } else if (key == MAKER_CHECKER_EVENT_TYPES_MLE.legal.toLowerCase()) {
        return 'Legal Details';
    } else {
        return '';
    }
}

export const REQUIRED_MSG = 'This field is required. ';